import React, { useState, useContext, useEffect } from 'react'

//router
import { Link, useLocation } from 'react-router-dom'

//react-bootstrap
import { Accordion, useAccordionButton, AccordionContext, Nav, Tooltip, OverlayTrigger } from 'react-bootstrap'
import { useNotification } from '../../../../context/NotificationContext';
import Cookies from 'js-cookie'
import api from '../../../../services/api';
import './styles.css'

function CustomToggle({ children, eventKey, onClick }) {

    const { activeEventKey } = useContext(AccordionContext);

    const decoratedOnClick = useAccordionButton(eventKey, (active) => onClick({ state: !active, eventKey: eventKey }));

    const isCurrentEventKey = activeEventKey === eventKey;

    return (
        <Link to="#" aria-expanded={isCurrentEventKey ? 'true' : 'false'} className="nav-link" role="button" onClick={(e) => {
            decoratedOnClick(isCurrentEventKey)
        }}>
            {children}
        </Link>
    );
}

const VerticalNav = React.memo(({ isSidebarMini }) => {
    const [activeMenu, setActiveMenu] = useState(false)
    const [active, setActive] = useState('')
    const logged_user = Cookies.get('userId')
    const [userPermissions, setUserPermissions] = useState([])
    //location
    let location = useLocation();
    const { isNewNotification, fetchNotification } = useNotification();

    const getUserPermisssions = async () => {
        try {
            const [userPermissionsResponse] = await Promise.all([
                api.get(`/api/permissions/user/${logged_user}`)
            ])

            setUserPermissions(userPermissionsResponse.data.userPermissions)
        } catch (error) {
            console.error('Erro')
        }
    }

    useEffect(() => {
        fetchNotification()
        getUserPermisssions()
    }, []);

    const handleMouseLeave = () => {
        setTimeout(() => {
            if(location.pathname === '/friends/friend-list' || location.pathname === '/friends/friend-request'){
                setActive('friends-menu');
            }else if(location.pathname === '/users/index' || location.pathname === '/permissions/index' || location.pathname === '/roles/index' || location.pathname === '/activitylogs/index' || location.pathname === '/positions/index' || location.pathname === '/dashboard/index'){
                setActive('gestao-menu');
            }else if(location.pathname === '/quiz/index' || location.pathname === '/polls/index' || location.pathname === '/sorteio/index'){
                setActive('interactions-menu');
            }else {
                setActive('0');
            } 
        }, 1000);
        console.log('Mouse left the sidebar');
    };

    return (
        <React.Fragment>
            <Accordion as="ul" className="navbar-nav iq-main-menu" id="sidebar-menu" activeKey={active} onMouseLeave={handleMouseLeave}>
                <li className="nav-item static-item">
                    <Link className="nav-link static-item disabled" to="#" tabIndex="-1">
                    </Link>
                </li>
                <li className={`${location.pathname === '/' ? 'active' : ''} nav-item `}>
                    <Link className={`${location.pathname === '/' ? 'active' : ''} nav-link `} id="feed" aria-current="page" to="/">
                        <OverlayTrigger placement="right" overlay={<Tooltip>Newsfeed</Tooltip>}>
                            <i className="icon material-symbols-outlined font-size-onmobile">
                                newspaper
                            </i>
                        </OverlayTrigger>
                        <span className="item-name font-size-onmobile">Newsfeed</span>
                    </Link>
                </li>

                <Accordion.Item as="li" eventKey="friends-menu" bsPrefix="nav-item">
                    <CustomToggle eventKey="friends-menu"  onClick={() => setActive('friends-menu')}>

                        <OverlayTrigger placement="right" overlay={<Tooltip>Amigos</Tooltip>}>
                            <i className="icon material-symbols-outlined font-size-onmobile">
                                people
                            </i>
                        </OverlayTrigger>
                        <span className="item-name font-size-onmobile">Amigos</span>
                        {/* <i className="right-icon material-symbols-outlined">chevron_right</i> */}
                    </CustomToggle>
                    <Accordion.Collapse eventKey="friends-menu">
                        <ul className="sub-nav">
                            <Nav.Item as="li">
                                <Link className={`${location.pathname === '/friends/friend-list' ? 'active' : ''} nav-link`} to="/friends/friend-list">
                                    <i className="icon material-symbols-outlined filled">
                                        people
                                    </i>

                                    <OverlayTrigger placement="right" overlay={<Tooltip>Meus amigos</Tooltip>}>
                                        <i className="sidenav-mini-icon icon material-symbols-outlined"> people </i>
                                    </OverlayTrigger>
                                    <span className="item-name font-size-onmobile">Meus amigos</span>
                                </Link>
                            </Nav.Item>
                            <Nav.Item as="li">
                                <Link className={`${location.pathname === '/friends/friend-request' ? 'active' : ''} nav-link`} to="/friends/friend-request">
                                    <i className="icon material-symbols-outlined filled">
                                        person_add_alt
                                    </i>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Solicitações</Tooltip>}>
                                        <i className="sidenav-mini-icon font-size-onmobile icon material-symbols-outlined"> person_add_alt </i>
                                    </OverlayTrigger>
                                    <span className="item-name font-size-onmobile">Solicitações</span>
                                </Link>
                            </Nav.Item>
                        </ul>
                    </Accordion.Collapse>
                </Accordion.Item>

                <Nav.Item as="li">
                    <Link className={`${location.pathname === '/groups/groups' ? 'active' : ''} nav-link `} aria-current="page" to="/groups/groups">
                        <OverlayTrigger placement="right" overlay={<Tooltip>Group</Tooltip>}>
                            <i className="icon material-symbols-outlined font-size-onmobile">
                                groups
                            </i>
                        </OverlayTrigger>
                        <span className="item-name font-size-onmobile">Grupos</span>
                    </Link>
                </Nav.Item>
                <Nav.Item as="li">
                    <Link className={`${location.pathname === '/events/index' ? 'active' : ''} nav-link `} aria-current="page" to="/events/index">
                        <OverlayTrigger placement="right" overlay={<Tooltip>Eventos</Tooltip>}>
                            <i className="icon material-symbols-outlined font-size-onmobile">
                                event
                            </i>
                        </OverlayTrigger>
                        <span className="item-name font-size-onmobile">Eventos</span>
                    </Link>
                </Nav.Item>
                <Nav.Item as="li">
                    <Link className={`${location.pathname === '/notifications/notification' ? 'active' : ''} nav-link `} aria-current="page" to="/notifications/notification">
                        <OverlayTrigger placement="right" overlay={<Tooltip>Notificações</Tooltip>}>
                            <i className="icon material-symbols-outlined font-size-onmobile">
                                notifications
                                {isNewNotification && isSidebarMini === true &&
                                    <i className="bg-primary text-white notification-badge-read"></i>
                                }
                            </i>
                        </OverlayTrigger>
                        <span className="item-name font-size-onmobile">Notificações
                            {isNewNotification && isSidebarMini === false &&
                                <span className="bg-primary text-white notification-badge-read"></span>
                            }
                        </span>
                    </Link>
                </Nav.Item>

                <Nav.Item as="li">
                    <Link className={`${location.pathname === '/knowledge/list' ? 'active' : ''} nav-link `} aria-current="page" to="/knowledge/list" >
                        <OverlayTrigger placement="right" overlay={<Tooltip>Conhecimentoteca</Tooltip>}>
                            <i className="icon material-symbols-outlined font-size-onmobile">
                                school
                            </i>
                        </OverlayTrigger>
                        <span className="item-name font-size-onmobile">Conhecimentoteca</span>
                    </Link>
                </Nav.Item>

                {
                    userPermissions.some((permission) => permission.name === 'see_live') ? (
                        <Nav.Item as="li">
                            <Link className={`${location.pathname === '/streaming/index' ? 'active' : ''} nav-link `} aria-current="page" to="/streaming/index" >
                                <OverlayTrigger placement="right" overlay={<Tooltip>Lives</Tooltip>}>
                                    <i className="icon material-symbols-outlined font-size-onmobile">
                                        videocam
                                    </i>
                                </OverlayTrigger>
                                <span className="item-name font-size-onmobile">Lives</span>
                            </Link>
                        </Nav.Item>
                    ) : ''
                }

                <Nav.Item as="li">
                    <Link className={`${location.pathname === '/vods/index' ? 'active' : ''} nav-link `} aria-current="page" to="/vods/index" >
                        <OverlayTrigger placement="right" overlay={<Tooltip>VODs</Tooltip>}>
                            <i className="icon material-symbols-outlined font-size-onmobile">
                                video_library
                            </i>
                        </OverlayTrigger>
                        <span className="item-name font-size-onmobile">VODs</span>
                    </Link>
                </Nav.Item>

                <Accordion.Item as="li" eventKey="gestao-menu" bsPrefix="nav-item">
                    {
                        userPermissions.some((permission) => permission.name === 'see_control_panel') ? (
                            <CustomToggle eventKey="gestao-menu" onClick={() => setActive('gestao-menu')}>
                                <OverlayTrigger placement="right" overlay={<Tooltip>Gestão</Tooltip>}>
                                    <i className="icon material-symbols-outlined font-size-onmobile">
                                        admin_panel_settings
                                    </i>
                                </OverlayTrigger>
                                <span className="item-name font-size-onmobile">Gestão</span>
                            </CustomToggle>
                        ) : ''
                    }

                    <Accordion.Collapse eventKey="gestao-menu" >
                        <ul className="sub-nav">
                            <Nav.Item as="li">
                                <Link className={`${location.pathname === '/users/index' ? 'active' : ''} nav-link`} to="/users/index">

                                    <i className="icon material-symbols-outlined font-size-onmobile">
                                        manage_accounts
                                    </i>

                                    <OverlayTrigger placement="right" overlay={<Tooltip>Usuários</Tooltip>}>
                                        <i className="icon sidenav-mini-icon material-symbols-outlined font-size-onmobile"> manage_accounts </i>
                                    </OverlayTrigger>
                                    <span className="item-name font-size-onmobile">Usuários</span>
                                </Link>
                            </Nav.Item>
                            <Nav.Item as="li">
                                <Link className={`${location.pathname === '/permissions/index' ? 'active' : ''} nav-link`} to="/permissions/index">

                                    <i className="icon material-symbols-outlined font-size-onmobile">
                                        shield_person
                                    </i>

                                    <OverlayTrigger placement="right" overlay={<Tooltip>Permissões</Tooltip>}>
                                        <i className="sidenav-mini-icon icon material-symbols-outlined font-size-onmobile"> shield_person </i>
                                    </OverlayTrigger>
                                    <span className="item-name font-size-onmobile">Permissões</span>
                                </Link>
                            </Nav.Item>
                            <Nav.Item as="li">
                                <Link className={`${location.pathname === '/roles/index' ? 'active' : ''} nav-link`} to="/roles/index">

                                    <i className="icon material-symbols-outlined">
                                        supervisor_account
                                    </i>

                                    <OverlayTrigger placement="right" overlay={<Tooltip>Roles</Tooltip>}>
                                        <i className="sidenav-mini-icon icon material-symbols-outlined"> supervisor_account </i>
                                    </OverlayTrigger>
                                    <span className="item-name font-size-onmobile">Perfis</span>
                                </Link>
                            </Nav.Item>
                            <Nav.Item as="li">
                                <Link className={`${location.pathname === '/activitylogs/index' ? 'active' : ''} nav-link`} to="/activitylogs/index">

                                    <i className="icon material-symbols-outlined">
                                        activity_zone
                                    </i>

                                    <OverlayTrigger placement="right" overlay={<Tooltip>Logs</Tooltip>}>
                                        <i className="sidenav-mini-icon icon material-symbols-outlined"> activity_zone </i>
                                    </OverlayTrigger>
                                    <span className="item-name font-size-onmobile">Logs</span>
                                </Link>
                            </Nav.Item>
                            <Nav.Item as="li">
                                <Link className={`${location.pathname === '/positions/index' ? 'active' : ''} nav-link`} to="/positions/index">

                                    <i className="icon material-symbols-outlined">
                                        tenancy
                                    </i>

                                    <OverlayTrigger placement="right" overlay={<Tooltip>Cargos</Tooltip>}>
                                        <i className="sidenav-mini-icon icon material-symbols-outlined"> tenancy </i>
                                    </OverlayTrigger>
                                    <span className="item-name font-size-onmobile">Cargos</span>
                                </Link>
                            </Nav.Item>
                            <Nav.Item as="li">
                                <Link className={`${location.pathname === '/dashboard/index' ? 'active' : ''} nav-link`} to="/dashboard/index">

                                    <i className="icon material-symbols-outlined">
                                        monitoring
                                    </i>

                                    <OverlayTrigger placement="right" overlay={<Tooltip>Relatórios</Tooltip>}>
                                        <i className="sidenav-mini-icon icon material-symbols-outlined"> monitoring </i>
                                    </OverlayTrigger>
                                    <span className="item-name font-size-onmobile">Relatórios</span>
                                </Link>
                            </Nav.Item>
                        </ul>
                    </Accordion.Collapse>
                </Accordion.Item>

                {
                    userPermissions.some((permission) =>
                        ['see_quiz', 'see_sorteio', 'see_enquete'].includes(permission.name)
                    ) && (
                        <Accordion.Item as="li" eventKey="interactions-menu" bsPrefix="nav-item">
                            <CustomToggle eventKey="interactions-menu" onClick={() => setActive('interactions-menu')}>
                                <OverlayTrigger placement="right" overlay={<Tooltip>Interações</Tooltip>}>
                                    <i className="icon material-symbols-outlined font-size-onmobile">
                                        touch_app
                                    </i>
                                </OverlayTrigger>
                                <span className="item-name font-size-onmobile">Interações</span>
                            </CustomToggle>

                            <Accordion.Collapse eventKey="interactions-menu" >
                                <ul className="sub-nav">

                                    {
                                        userPermissions.some((permission) => permission.name === 'see_quiz') && (
                                            <Nav.Item as="li">
                                                <Link className={`${location.pathname === '/quiz/index' ? 'active' : ''} nav-link`} to="/quiz/index">
                                                    <i className="icon material-symbols-outlined font-size-onmobile">
                                                        quiz
                                                    </i>

                                                    <OverlayTrigger placement="right" overlay={<Tooltip>Quiz</Tooltip>}>
                                                        <i className="icon sidenav-mini-icon material-symbols-outlined">
                                                            quiz
                                                        </i>
                                                    </OverlayTrigger>
                                                    <span className="item-name font-size-onmobile">Quiz</span>
                                                </Link>
                                            </Nav.Item>
                                        )
                                    }

                                    {
                                        userPermissions.some((permission) => permission.name === 'see_enquete') && (
                                            <Nav.Item as="li">
                                                <Link className={`${location.pathname === '/polls/index' ? 'active' : ''} nav-link`} to="/polls/index">
                                                    <i className="icon material-symbols-outlined ">
                                                        ballot
                                                    </i>

                                                    <OverlayTrigger placement="right" overlay={<Tooltip>Enquete</Tooltip>}>
                                                        <i className="icon sidenav-mini-icon material-symbols-outlined">
                                                            ballot
                                                        </i>
                                                    </OverlayTrigger>
                                                    <span className="item-name font-size-onmobile">Enquete</span>
                                                </Link>
                                            </Nav.Item>
                                        )
                                    }

                                    {
                                        userPermissions.some((permission) => permission.name === 'see_sorteio') && (
                                            <Nav.Item as="li">
                                                <Link className={`${location.pathname === '/sorteio/index' ? 'active' : ''} nav-link`} to="/sorteio/index">
                                                    <i className="icon material-symbols-outlined ">
                                                        trophy
                                                    </i>

                                                    <OverlayTrigger placement="right" overlay={<Tooltip>Sorteio</Tooltip>}>
                                                        <i className="icon sidenav-mini-icon material-symbols-outlined">
                                                            trophy
                                                        </i>
                                                    </OverlayTrigger>
                                                    <span className="item-name font-size-onmobile">Sorteio</span>
                                                </Link>
                                            </Nav.Item>
                                        )
                                    }


                                </ul>
                            </Accordion.Collapse>
                        </Accordion.Item>
                    )
                }



                <Nav.Item as="li">
                    <Link className={`${location.pathname === '/organograma/index' ? 'active' : ''} nav-link `} aria-current="page" to="/organograma/index" >
                        <OverlayTrigger placement="right" overlay={<Tooltip>Organograma</Tooltip>}>
                            <i className="icon material-symbols-outlined font-size-onmobile">
                                account_tree
                            </i>
                        </OverlayTrigger>
                        <span className="item-name font-size-onmobile">Organograma</span>
                    </Link>
                </Nav.Item>
                <Nav.Item as="li">
                    <Link className={`${location.pathname === '/equipes/index' ? 'active' : ''} nav-link `} aria-current="page" to="/equipes/index" >
                        <OverlayTrigger placement="right" overlay={<Tooltip>Organograma</Tooltip>}>
                            <i className="icon material-symbols-outlined font-size-onmobile">
                                groups
                            </i>
                        </OverlayTrigger>
                        <span className="item-name font-size-onmobile">Equipes</span>
                    </Link>
                </Nav.Item>

                <Nav.Item as="li">
                    <Link className={`${location.pathname === '/upload/index' ? 'active' : ''} nav-link `} aria-current="page" to="/upload/index" >
                        <OverlayTrigger placement="right" overlay={<Tooltip>Drive Workplace</Tooltip>}>
                            <i className="icon material-symbols-outlined font-size-onmobile">
                                upload_file
                            </i>
                        </OverlayTrigger>
                        <span className="item-name font-size-onmobile">Drive</span>
                    </Link>
                </Nav.Item>

                <Accordion.Item as="li" eventKey="intranet-menu" bsPrefix="nav-item" style={{ marginBottom: '50px' }}>
                    <CustomToggle eventKey="intranet-menu" onClick={() => setActive('intranet-menu')}>

                        <OverlayTrigger placement="right" overlay={<Tooltip>Sistemas Atmo</Tooltip>}>
                            <i className="icon material-symbols-outlined font-size-onmobile">
                                linked_services
                            </i>
                        </OverlayTrigger>
                        <span className="item-name font-size-onmobile">Sistemas Atmo</span>
                    </CustomToggle>
                    <Accordion.Collapse eventKey="intranet-menu" >
                        <ul className="sub-nav">
                            <Nav.Item as="li">
                                <Link className='nav-link' to="kitchen">
                                    <i className="icon material-symbols-outlined font-size-onmobile">
                                        lunch_dining
                                    </i>

                                    <OverlayTrigger placement="right" overlay={<Tooltip>Atmo Kitchen</Tooltip>}>
                                        <i className="icon sidenav-mini-icon material-symbols-outlined">
                                            lunch_dining
                                        </i>
                                    </OverlayTrigger>
                                    <span className="item-name font-size-onmobile">Atmo Kitchen</span>
                                </Link>
                            </Nav.Item>
                            <Nav.Item as="li">
                                <Link className='nav-link' to="https://live.atmodigital.com/login" target='_blank'>
                                    <i className="icon material-symbols-outlined">
                                        live_tv
                                    </i>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Atmo Live</Tooltip>}>
                                        <i className="icon sidenav-mini-icon material-symbols-outlined">
                                            live_tv
                                        </i>
                                    </OverlayTrigger>
                                    <span className="item-name font-size-onmobile">Atmo Live</span>
                                </Link>
                            </Nav.Item>
                            <Nav.Item as="li">
                                <Link className='nav-link' to="https://ds.publicador.atmodigital.com/publicador/login" target='_blank'>
                                    <i className="icon material-symbols-outlined">
                                        web
                                    </i>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Atmo Publicador</Tooltip>}>
                                        <i className="icon sidenav-mini-icon material-symbols-outlined">
                                            web
                                        </i>
                                    </OverlayTrigger>
                                    <span className="item-name font-size-onmobile">Atmo Publicador</span>
                                </Link>
                            </Nav.Item>
                            <Nav.Item as="li">
                                <Link className='nav-link' to="https://radio.atmodigital.tech/login" target='_blank'>
                                    <i className="icon material-symbols-outlined">
                                        radio
                                    </i>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Atmo Radio</Tooltip>}>
                                        <i className="icon sidenav-mini-icon material-symbols-outlined">
                                            radio
                                        </i>
                                    </OverlayTrigger>
                                    <span className="item-name font-size-onmobile">Atmo Radio</span>
                                </Link>
                            </Nav.Item>
                            <Nav.Item as="li">
                                <Link className='nav-link' to="https://drive.atmodigital.com/login" target='_blank'>
                                    <i className="icon material-symbols-outlined">
                                        cloud
                                    </i>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Atmo Drive</Tooltip>}>
                                        <i className="icon sidenav-mini-icon material-symbols-outlined">
                                            cloud
                                        </i>
                                    </OverlayTrigger>
                                    <span className="item-name font-size-onmobile">Atmo Drive</span>
                                </Link>
                            </Nav.Item>
                            <Nav.Item as="li">
                                <Link className='nav-link' to="https://www.omie.com.br/" target='_blank'>
                                    <i className="icon material-symbols-outlined">
                                        description
                                    </i>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>OMIE</Tooltip>}>
                                        <i className="icon sidenav-mini-icon material-symbols-outlined">
                                            description
                                        </i>
                                    </OverlayTrigger>
                                    <span className="item-name font-size-onmobile">OMIE</span>
                                </Link>
                            </Nav.Item>
                            <Nav.Item as="li">
                                <Link className='nav-link' to="https://launchpad.37signals.com/basecamp" target='_blank'>
                                    <i className="icon material-symbols-outlined">
                                        calendar_month
                                    </i>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Basecamp</Tooltip>}>
                                        <i className="icon sidenav-mini-icon material-symbols-outlined">
                                            calendar_month
                                        </i>
                                    </OverlayTrigger>
                                    <span className="item-name font-size-onmobile">Basecamp</span>
                                </Link>
                            </Nav.Item>
                            <Nav.Item as="li">
                                <Link className='nav-link' to="https://www.pipedrive.com/pt" target='_blank'>
                                    <i className="icon material-symbols-outlined">
                                        view_timeline
                                    </i>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Pipedrive</Tooltip>}>
                                        <i className="icon sidenav-mini-icon material-symbols-outlined">
                                            view_timeline
                                        </i>
                                    </OverlayTrigger>
                                    <span className="item-name font-size-onmobile">Pipedrive</span>
                                </Link>
                            </Nav.Item>
                            <Nav.Item as="li">
                                <Link className='nav-link' to="https://tickets.atmodigital.tech/login" target='_blank'>
                                    <i className="icon material-symbols-outlined">
                                        support_agent
                                    </i>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>Atmo Tickets</Tooltip>}>
                                        <i className="icon sidenav-mini-icon material-symbols-outlined">
                                            support_agent
                                        </i>
                                    </OverlayTrigger>
                                    <span className="item-name font-size-onmobile">Atmo Tickets</span>
                                </Link>
                            </Nav.Item>
                        </ul>
                    </Accordion.Collapse>
                </Accordion.Item>

            </Accordion>
        </React.Fragment >
    )
})

export default VerticalNav
